module.exports = __webpack_public_path__ + "img/icon_ht_user.ab1bd85e.svg";